export default "__VITE_ASSET__CuQu9ZU1__"